import { Box, Container, Heading, Stack, useTheme } from "@chakra-ui/react";
import React from "react";
import IntroText from "./IntroText";

type IntroHeroBlockProps = {
  mainHeadingRef: React.RefObject<HTMLHeadingElement | null>;
};

export default function IntroHeroBlock({
  mainHeadingRef,
}: IntroHeroBlockProps) {
  const theme = useTheme();
  const navy800 = (theme.colors as any)?.navy?.[800] || "#283B5A";
  return (
    <Box bg={navy800} color="white" py={{ base: 8, md: 10 }}>
      <Container maxW="96rem" px={{ base: 4, md: 6, xl: 8 }}>
        <Stack spacing={6}>
          <Heading
            id="cdd-main-heading"
            ref={mainHeadingRef}
            tabIndex={-1}
            as="h1"
            fontSize={{ base: "2xl", md: "3xl" }}
            letterSpacing="wide"
          >
            Centralized Disciplinary Database
          </Heading>

          <Box
            bg="white"
            color="gray.800"
            borderRadius="md"
            p={{ base: 4, md: 6 }}
          >
            <IntroText />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
